import React from 'react';

import { default as ListItemText } from '@material-ui/core/ListItemText';

import TranslationHelper from '../../../helpers/TranslationHelper';

import { IReport } from '../../../state/types';
import { useStyles } from './Themable.hooks';

interface IOwnProps {
    report: IReport;
}

const ReportLabel = ({ report }: IOwnProps) => {
    const classes = useStyles();
    return (
        <>
            <ListItemText
                primary={
                    report.labelParams
                        ? TranslationHelper.translateFormat(
                              report.label,
                              report.labelParams,
                              report.translate
                          )
                        : TranslationHelper.translate(report.label)
                }
                className={classes.heading}
            />
        </>
    );
};

export default ReportLabel;
